module.exports = __webpack_public_path__ + "static/media/logo.379283a5.png";